module.exports = __webpack_public_path__ + "img/tel.245cafbc.png";